import { FC } from 'react';

import { useCurrentPromoter } from '@hooks/PromoterHooks/useCurrentPromoter';
import { useCitiesQuery, useCurrentUserCity } from '@hooks/useCurrentUserLocation';

import { useRouter } from '@router/index';

import { Screen } from '@components/layout/Screen/Screen';
import { Skeleton } from '@components/layout/Skeleton/Skeleton';

import { PromoterForm } from '../ManagePromoterProfileScreen/PromoterForm';

export const EditPromoterProfileScreen: FC<{}> = () => {
  const { promoter } = useCurrentPromoter();
  const { currentCity: currentUserCity } = useCurrentUserCity();
  const { cities } = useCitiesQuery();
  const { back } = useRouter();

  const handleSave = () => {
    back();
  };

  const currentCity =
    currentUserCity ?? cities?.find((city) => promoter?.cityIds?.includes(city._id));

  return (
    <Screen
      name="Edit Promoter Profile Screen"
      hideToolbar
      headerProps={{
        back: { to: '/manage/promoter' },
        title: 'Edit Profile',
      }}
    >
      <Screen.Content>
        {promoter && cities?.length ? (
          <PromoterForm
            currentCity={currentCity}
            cities={cities ?? []}
            promoter={promoter}
            onSave={handleSave}
          />
        ) : (
          <>
            <Skeleton height={42} />
            <Skeleton height={42} />
            <Skeleton height={42} />
          </>
        )}
      </Screen.Content>
    </Screen>
  );
};
